export const BSPOptionsRoutes = {
    ROOT: "/BSP-options",
    PAYOUT: "/BSP-option-Payout",
    DETAILS: "/BSP-options/details",
    SUMMARY: "/BSP-options/summary",
    SIGNING: "/BSP-options/signing",
    SUCCESS: "/BSP-options/success",
    PDF: "/BSP-options/:id/pdf/:webUrl"
};



// WEBPACK FOOTER //
// ./src/components/BSPOptions/BSPOptionsRoutes.ts